import { __awaiter } from "tslib";
import { dictionary } from "@app/services/currentDictionary.service";
import { get, writable } from "svelte/store";
import { searchPhrase } from "../Search/Search.store";
const automaticTranslationStore = writable([]);
export function memorizeAutomaticTranslationResult(result) {
    automaticTranslationStore.update(storedResults => {
        return [...storedResults.filter(oneStoredResult => result.provider !== oneStoredResult.provider), result];
    });
}
export function getLastAutomaticTranslationResultForProvider(provider) {
    return get(automaticTranslationStore).find(result => result.provider === provider);
}
export function automaticTranslationProviderForCurrentDictionaryAndPhrase(provider) {
    const currentDictionary = get(dictionary);
    const currentSearchPhrase = get(searchPhrase);
    return () => __awaiter(this, void 0, void 0, function* () { return provider({ l1Code: currentDictionary.l1.code, l2Code: currentDictionary.l2.code, text: currentSearchPhrase }); });
}
export function automaticTranslationProviderForCurrentDictionary(provider, text) {
    const currentDictionary = get(dictionary);
    return () => __awaiter(this, void 0, void 0, function* () { return provider({ l1Code: currentDictionary.l1.code, l2Code: currentDictionary.l2.code, text }); });
}
